/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import DownloadCard from "../downloadpage/sub-components/DownloadCard";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "1.875rem",
  },
}));

const SectionTwo = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div className={classes.flex}>
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Partner with us"
            href="https://bucket.beegru.in/agent_partner.png"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SectionTwo;
